export const SLIDE_FOLDER = 'assets/slides';
